
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySparNorth as ObiBuoySparNorthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spar-north.js';
 
 
 

 
 export const ObiBuoySparNorth = createComponent({
   react: React,
   tagName: 'obi-buoy-spar-north',
   elementClass: ObiBuoySparNorthElement,
   events: {
     
   }
  });
 
 